/** The first focusable thing on every page: a link to #main that appears on focus. */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only rounded-lg bg-accent px-4 py-2 font-medium text-on-accent no-underline focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50"
    >
      Skip to main content
    </a>
  );
}
